export default String.raw`
<template id="coupon-popup-template">
    <dialog class="dialog coupons-popup">
        <div class="popup__header">
            <h2 class="title">{{ translations.AvailableCoupons }}</h2>
            <form method="dialog">
                <button class="close-dialog-btn">
                    <svg class="close-js">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
                    </svg>
                </button>
            </form>
        </div>
        
        <div class="popup__content">
            <div class="product-info">
                <div class="product__image-wrapper"></div>
                <div class="product__info">
                    <div class="name-code-container__name"></div>
                    <div class="name-code-container__code"></div>
                </div>
            </div>
        </div>

        <div class="coupon-popup-body">
            <div class="tab-content">
                <div class="tab-panel active" data-panel="coupons">
                    <div class="coupons-skeleton-loader coupons-skeleton-loader-js">
                        <div class="coupon-skeleton-item">
                            <div class="skeleton-info">
                                <div class="skeleton-first-row">
                                    <div class="skeleton-icon"></div>
                                    <div class="skeleton-line skeleton-type"></div>
                                    <div class="skeleton-line skeleton-code"></div>
                                </div>
                                <div class="skeleton-line skeleton-validity"></div>
                            </div>
                            <div class="skeleton-button"></div>
                        </div>
                        <div class="coupon-skeleton-item">
                            <div class="skeleton-info">
                                <div class="skeleton-first-row">
                                    <div class="skeleton-icon"></div>
                                    <div class="skeleton-line skeleton-type"></div>
                                    <div class="skeleton-line skeleton-code"></div>
                                </div>
                                <div class="skeleton-line skeleton-validity"></div>
                            </div>
                            <div class="skeleton-button"></div>
                        </div>
                        <div class="coupon-skeleton-item">
                            <div class="skeleton-info">
                                <div class="skeleton-first-row">
                                    <div class="skeleton-icon"></div>
                                    <div class="skeleton-line skeleton-type"></div>
                                    <div class="skeleton-line skeleton-code"></div>
                                </div>
                                <div class="skeleton-line skeleton-validity"></div>
                            </div>
                            <div class="skeleton-button"></div>
                        </div>
                        <div class="coupon-skeleton-item">
                            <div class="skeleton-info">
                                <div class="skeleton-first-row">
                                    <div class="skeleton-icon"></div>
                                    <div class="skeleton-line skeleton-type"></div>
                                    <div class="skeleton-line skeleton-code"></div>
                                </div>
                                <div class="skeleton-line skeleton-validity"></div>
                            </div>
                            <div class="skeleton-button"></div>
                        </div>
                    </div>
                    
                    <div class="coupons-list-in-popup coupons-list-in-popup-js"></div>
                </div>
            </div>
        </div>

        <div class="coupon-popup-footer">
            <button class="close-popup-btn close-dialog-btn primary-action-button">{{ translations.Close }}</button>
        </div>
    </dialog>
</template>

`